export default __webpack_public_path__ + "static/media/podcasts.d0d819fe.svg";